<template>
  <base-side-page
    @cancel="cancelSidePage"
    :title="$t('bill.rate.title.rate')"
    icon="res-rate"
    :res-name="getBillResourceTypeLabel(detailData.resource_type)"
    :current-tab="params.windowData.currentTab"
    :loaded="loaded"
    :tabs="detailTabs"
    @tab-change="handleTabChange">
    <component :is="params.windowData.currentTab" :res-id="data.id" :data="detailData" :params="params" />
  </base-side-page>
</template>

<script>
import { toVmName } from '@Bill/views/rate/utils'
import SidePageMixin from '@/mixins/sidePage'
import WindowsMixin from '@/mixins/windows'
import { getBillResourceTypeLabel } from '@Bill/utils'
import ColumnsMixin from '../mixins/columns'
import History from './History'

export default {
  name: 'BillRateSidePage',
  components: {
    History,
  },
  mixins: [SidePageMixin, WindowsMixin, ColumnsMixin],
  data () {
    return {
      detailTabs: [
        { label: this.$t('bill.text_170'), key: 'history' },
        { label: this.$t('compute.text_240'), key: 'event-drawer' },
      ],
    }
  },
  methods: {
    toVmName,
    getBillResourceTypeLabel,
  },
}
</script>
